import React, { useEffect, useState } from "react";
// import queryString from "query-string";
import style from "./index.module.scss";
// import styled from "styled-components";
import { Data, Func, Style } from "../../config";
import imgBg from "./img_bg.png";

export interface IAppProps extends Data, Func, Style {
  keyword: any;
  // mainTitle: string;
  // subTitle: string;
  // backImageUrl: string;
  // layoutType: string;
  // vInterval: string;
  // hInterval: string;
  // minHeight: string;
  // desc: string;
  // padding: string;
  // maxWidth: string;
  // link: [{ styleType: string; link: string; text: string }];
  // searchBar: { phText: string; icon: string; keywords: [{ text: string; link: string }]; redirectUrl: string };
  // mainColor: string;
  // arrFontSize: [
  //   {
  //     mainTitle: string;
  //     subTitle: string;
  //     desc: string;
  //   },
  // ];
}
const getUrlParam = (paraName: string) => {
  const url = document.location.toString();
  const arrObj = url.split("?");

  if (arrObj.length > 1) {
    const arrPara = arrObj[1].split("&");
    let arr;

    for (let i = 0; i < arrPara.length; i++) {
      arr = arrPara[i].split("=");

      if (arr != null && arr[0] == paraName) {
        return arr[1];
      }
    }
    return "";
  } else {
    return "";
  }
};
const App: React.FC<IAppProps> = props => {
  const {
    mainTitle,
    subTitle,
    // backImageUrl,
    layoutType,
    vInterval,
    hInterval,
    minHeight,
    maxWidth,
    desc,
    padding,
    link,
    searchBar,
    arrFontSize,
    mainColor,
  } = props;
  console.log(props);

  const [searchKeyword, setSearchKeyword] = useState("");

  const getKeyWord = () => {
    const { keyword } = props;
    const kw = decodeURI(getUrlParam("searchText"));
    setSearchKeyword(keyword || kw);
  };

  useEffect(() => {
    getKeyWord();
  }, []);

  return (
    <div className={`${style.app} ${style.appContaner}`}>
      <div
        className={`${style.banner} ${searchBar && searchBar.phText !== "" ? style.helpCenter : ""}`}
        style={{
          background: `url(${imgBg}) no-repeat 0 0 / 100% 100%`,
          minHeight: minHeight,
          padding: padding,
        }}
      >
        <div className={`${style.titleWrapper}`}>
          {layoutType === "v" && (
            <div
              className={`${style.content} ${style.vertical}`}
              style={{
                maxWidth: maxWidth,
              }}
            >
              {mainTitle && (
                <p
                  className={style.mainTitle}
                  style={{
                    marginBottom: vInterval && JSON.parse(vInterval)[0] ? JSON.parse(vInterval)[0] : "",
                    fontSize: arrFontSize && arrFontSize[0] && arrFontSize[0].mainTitle,
                  }}
                >
                  {mainTitle}
                </p>
              )}
              {subTitle && (
                <p
                  className={style.subTitle}
                  style={{
                    marginBottom: vInterval && JSON.parse(vInterval)[1] ? JSON.parse(vInterval)[1] : "",
                    fontSize: arrFontSize && arrFontSize[0] && arrFontSize[0].subTitle,
                  }}
                >
                  {subTitle}
                </p>
              )}
              {desc && (
                <p
                  className={style.desc}
                  style={{
                    marginBottom: vInterval && JSON.parse(vInterval)[2] ? JSON.parse(vInterval)[2] : "",
                    fontSize: arrFontSize && arrFontSize[0] && arrFontSize[0].desc,
                  }}
                >
                  {desc}
                </p>
              )}
            </div>
          )}

          {layoutType === "h" && (
            <div
              className={`${style.content} ${style.horizontal}`}
              style={{
                maxWidth: maxWidth,
                marginBottom: vInterval && JSON.parse(vInterval)[0] ? JSON.parse(vInterval)[0] : "",
                fontSize: arrFontSize && arrFontSize[0] && arrFontSize[0].mainTitle,
              }}
            >
              <div
                style={{
                  marginRight: hInterval && JSON.parse(hInterval)[0] ? JSON.parse(hInterval)[0] : "",
                  textAlign: "right",
                  maxWidth: "400px",
                  fontSize: arrFontSize && arrFontSize[0] && arrFontSize[0].subTitle,
                }}
              >
                {mainTitle && (
                  <p
                    className={style.mainTitle}
                    style={{
                      marginBottom: hInterval && JSON.parse(vInterval)[1] ? JSON.parse(vInterval)[1] : "",
                      fontSize: arrFontSize && arrFontSize[0] && arrFontSize[0].mainTitle,
                    }}
                  >
                    {mainTitle}
                  </p>
                )}
                {subTitle && (
                  <p
                    className={style.subTitle}
                    style={{
                      fontSize: arrFontSize && arrFontSize[0] && arrFontSize[0].subTitle,
                    }}
                  >
                    {subTitle}
                  </p>
                )}
              </div>
              {desc && (
                <p
                  className={style.desc}
                  style={{
                    textAlign: "left",
                    maxWidth: "496px",
                    fontSize: arrFontSize && arrFontSize[0] && arrFontSize[0].desc,
                  }}
                >
                  {desc}
                </p>
              )}
            </div>
          )}
        </div>
        {link && link[0] && link[0].link && (
          <div className={style.linkWrapper}>
            {link.map((item, index) => (
              <a
                key={index}
                href={item.link}
                className={`${style.link}`}
                style={{
                  background: item.styleType === "filled" ? mainColor : "none",
                  border: item.styleType === "outline" ? "1px solid rgba(255,255,255,1)" : "none",
                }}
              >
                {item.text}
              </a>
            ))}
          </div>
        )}

        {searchBar && searchBar.phText !== "" && (
          <div>
            <div className={style.searchBar}>
              <div className={style.inputWrapper}>
                <input
                  type="text"
                  onChange={e => {
                    setSearchKeyword(e.target.value);
                  }}
                  value={searchKeyword}
                  placeholder={searchBar.phText}
                  onKeyUp={event => {
                    if (event.keyCode === 13) {
                      if (!searchKeyword.trim()) return;
                      window.location.href = "/searchlist?searchText=" + searchKeyword.trim();
                    }
                  }}
                />
              </div>
              <div
                className={style.iconWrapper}
                style={{
                  background: mainColor,
                }}
                onClick={() => {
                  if (!searchKeyword.trim()) return;
                  window.location.href = "/searchlist?searchText=" + searchKeyword.trim();
                }}
              >
                <em
                  className={style.icon}
                  style={{
                    background: `url(${searchBar.icon}) no-repeat 0 0 / 100% 100%`,
                    width: "16px",
                    height: "22px",
                  }}
                />
              </div>
            </div>
            {searchBar.keywords && searchBar.keywords[0].text && (
              <ul className={style.keywordsWrapper}>
                {searchBar.keywords.map((item, index) => (
                  <li key={index}>
                    <a href={item.link}>{item.text}</a>
                  </li>
                ))}
              </ul>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default App;
